import { CoreMenu } from '@core/types'

export const menu: CoreMenu[] = [
  
  // {
  //   id: 'dashboard',
  //   title: 'Dashboard',
  //   type: 'collapsible',
  //   icon: 'home',
  //   children: [
  //     {
  //       id: 'analytics',
  //       title: 'Over All',
  //       type: 'item',
  //       icon: 'circle',
  //       url: 'dashboard/analytics'
  //     },
   
  //   ]
  // },
  // {
  //   id: 'home',
  //   title: 'Home',
  //   type: 'item',
  //   icon: 'home',
  //   role: [],
  //   url: 'home'
  // }
  // {
  //   id: 'dashboard',
  //   title: 'Dashboard',
  //   type: 'item',
  //   icon: 'user-check',
  //   role: ['SuperAdmin','Admin'],
  //   url: 'admin/'
  // },
  {
    id: 'members',
    title: 'Members',
    type: 'item',
    icon: 'user-check',
    role: ['SuperAdmin','Admin'],
    url: 'admin/members'
  },
  // {
  //   id: 'loans',
  //   title: 'Loans',
  //   type: 'item',
  //   icon: 'user-check',
  //   role: ['SuperAdmin','Admin','BranchAdmin','Collector'],
  //   url: 'admin/loans'
  // },
  {
    id: 'itinerary',
    title: 'Itinerary',
    type: 'item',
    icon: 'clipboard',
    role: ['Collector'],
    url: 'admin/itinerary'
  },
  {
    id: 'collector-itinerary',
    title: 'Collector Itinerary',
    type: 'item',
    icon: 'clipboard',
    role: ['SuperAdmin','Admin','BranchAdmin'],
    url: 'admin/collector-itinerary'
  },
  {
    id: 'loans',
    title: 'Loans',
    type: 'collapsible',
    icon: 'assets/images/icons/loan.svg',
    role: ['SuperAdmin','Admin','BranchAdmin','Collector'],
    children: [
      {
        id: "toCollect",
        title: "To Collect",
        type: "item",
        url: "admin/loans/to-collect-loan",
      },
      {
        id: "pending",
        title: "Pending",
        type: "item",
        url: "admin/loans/pending-loan",
      },
      {
        id: "fullyPaid",
        title: "Fully Paid",
        type: "item",
        url: "admin/loans/fully-paid-loan",
      },
      {
        id: "promiseToPayLoan",
        title: "Promise To Pay Loan",
        type: "item",
        url: "admin/loans/promise-to-pay-loan",
      },
    ]
  },
  // {
  //   id: 'calendar',
  //   title: 'Calendar',
  //   type: 'item',
  //   icon: 'calendar',
  //   role: ['SuperAdmin','Admin'],
  //   url: 'admin/calendar'
  // }, 
  
  {
    id: 'reports',
    title: 'Reports',
    type: 'item',
    icon: 'book',
    role: ['SuperAdmin','Admin','BranchAdmin','Collector'],
    url: 'admin/reports'
  },
  {
    id: 'administration',
    title: 'Administration',
    type: 'collapsible',
    icon: 'settings',
    role: ['SuperAdmin','Admin'],
    children: [
      {
        id: "users",
        title: "Users",
        type: "item",
        url: "admin/administration/users",
      },
      {
        id: "branch",
        title: "Branch",
        type: "item",
        url: "admin/administration/branch",
      },
      {
        id: "loanType",
        title: "Loan Type",
        type: "item",
        url: "admin/administration/loanType",
      },
    ]
  },
]
